import React from 'react';
import {Table, Tag} from 'antd';
import {connect} from 'react-redux'

export const colorArray = {
    verification: {
        "Undeclined": '#ff7875',
        "Verified": '#fa8c16',
        "Unverified": '#ffc069',
        "Declined": '#a8071a'
    },
    payment: {
        "none": '#000',
        "order-verified": '#91caff',
        "buyer-paid": '#0958d9',
        "buyer-unpaid": '#91caff',
        "refunded": '#13c2c2',
        "partially-paid": '#4096ff'
    },
    fulfillment: {
        "fulfilled": '#722ed1',
        "none": '#b37feb',
        "canceled": '#ff85c0'
    },
    type: {
        "Original": "#a8071a",
        "Print": "#f5222d",
        "Commission": "#ff7875"
    }
}

export function getFulfillmentStr(status) {
    if (status === 'order-canceled') return 'canceled'
    if (status === 'fulfilled' || status === 'payment-settled') return 'fulfilled'
    return 'none'
}

export function getPaymentStr(status) {
    if (status === 'paid') return 'buyer-paid'
    if (status === 'unpaid') return 'buyer-unpaid'
    if (status === 'partially-paid') return 'partially-paid'
    if (status === 'refunded') return 'refunded'
    return 'none'
}

export function getPaymentText(status) {
    if (status === 'paid') return 'Buyer Paid'
    if (status === 'unpaid') return 'Buyer Unpaid'
    if (status === 'partially-paid') return 'Partially Paid'
    if (status === 'refunded') return 'Refunded'
    return 'none'
}

export function getVerificationStr(status) {
    if (!status || status === 'none' || status === 'buyer-paid') return 'Unverified'
    return 'Verified'
}

export function getSKUTypeStr(type) {
    if (type === 'prints') return "Print"
    if (type === 'original') return "Original"
    if (type === 'commission') return "Commission"
    return type
}

export const orderColumns = [
    {
        title: 'Order',
        dataIndex: 'id',
        key: 'id',
        editable: false,
        width: 128,
        sorter: (a, b) => a.id - b.id,
        ellipsis: true,
        render: (text) => <>#{text}</>
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        editable: false,
        width: 128,
        sorter: (a, b) => new Date(a.date) - new Date(b.date),
        ellipsis: true
    },
    {
        title: 'Artwork Name',
        dataIndex: 'sku_name',
        key: 'artwork',
        width: 128,
        editable: false,
        sorter: (a, b) => a.sku_name.localeCompare(b.sku_name)
    },
    {
        title: 'Verification',
        dataIndex: 'order_status',
        width: 128,
        editable: false,
        key: 'verification',
        render: (text, value) => (
            <Tag color={colorArray.verification[getVerificationStr(text)]}>{getVerificationStr(text)}</Tag>
        )
    },
    {
        title: 'Fulfillment',
        dataIndex: 'order_status',
        width: 128,
        key: 'fulfillment',
        render: (text, value) => (
            <Tag color={colorArray.fulfillment[getFulfillmentStr(text)]}>{
                text === "order-canceled" ? "Canceled" :
                    (text === "fulfilled" || text === 'payment-settled') ? "Fulfilled" : "UnFulfilled"}</Tag>
        )
    },
    {
        title: 'Type',
        dataIndex: 'sku_type',
        key: 'type',
        width: 128,
        render: (text, value) => (
            <Tag color={colorArray.type[getSKUTypeStr(text)]}>{getSKUTypeStr(text)}</Tag>
        )
    },
    {
        title: 'Price',
        dataIndex: 'sku_price',
        key: 'price',
        width: 128,
        sorter: (a, b) => b.sku_price - a.sku_price,
        render: (text) => <>${Number(text)?.toLocaleString() || ''}</>
    },
    {
        title: 'Quantity',
        dataIndex: 'sku_quantity',
        key: 'quantity',
        width: 128,
        sorter: (a, b) => b.sku_quantity - a.sku_quantity,
        render: (_, {sku_quantity}) => <>x{parseInt(sku_quantity) || 1}</>
    },
];
const mapStateToProps = function (state) {
    return {
        filters: state.order.filters,
        dateRange: state.order.dateRange,
        search: state.order.search,
        allOrders: state.order.allOrders
    }
}
export default connect(mapStateToProps)(OrderTable);

function OrderTable(props) {
    const {filters, dateRange, search, allOrders} = props;
    let filteredOrders = allOrders;
    if (search.length > 0) {
        filteredOrders = filteredOrders.filter(function (item) {
            const name = item.sku_name;
            if (item.sku_name.toUpperCase().includes(search.toUpperCase())) {
                return true;
            }
            return false;
        })
    }
    if (Object.keys(filters).length !== 0) {
        filteredOrders = filteredOrders.filter(function (item) {
            for (var key in filters) {
                if (filters[key].length !== 0 && !filters[key].includes(item[key])) {
                    return false;
                }
            }
            return true;
        })
    }

    if (Object.keys(dateRange).length !== 0) {
        filteredOrders = filteredOrders.filter(function (item) {
            const date = new Date(item.date);
            const startDate = new Date(dateRange.start);
            const endDate = new Date(dateRange.end);
            if (date >= startDate && date <= endDate) {
                return true;
            } else {
                return false;
            }
        })
    }

    return (
        <Table dataSource={filteredOrders} columns={orderColumns} scroll={{x: true}}/>
    )
}